@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.manage-presets-modal {
  width: 445px;
}

.modal-body {
  padding: 15px;
  max-height: 545px;
  overflow: auto;
}

.manage-presets-modal-footer {
  height: auto;
  text-align: left;

  .first-link {
    border-bottom: 1px solid @manage-presets-modal--footer-first-link--border-color;
  }

  .manage-presets-link-and-button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
  }
}

.loading-indicator-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .loading-indicator {
    height: 100px;
    width: 100px;
  }
}
